import React from "react";
import { Collapse } from "antd";

import { questionsData } from "../utils/questionsData";

import classes from "./Question.module.css";

const { Panel } = Collapse;

const Question = () => {
  return (
    <div className={classes["wrapper"]}>
      <Collapse className={classes["collapse-style"]}>
        {questionsData.map((value, index) => {
          return (
            <Panel
              showArrow={false}
              className={classes["collapse-wrapper"]}
              header={
                <div className={classes["collapse"]}>
                  <p className={classes["circle"]}>{index + 1}</p>
                  <p className={classes["title"]}>{value.title}</p>
                </div>
              }
              key={value.id}
            >
              <p className={classes["text"]}>{value.item}</p>
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};

export default Question;
